/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeImage } from "../../d-image";
import { DThemeDarkImageBase } from "./d-theme-dark-image-base";

export class DThemeDarkImage<VALUE = unknown>
	extends DThemeDarkImageBase<VALUE>
	implements DThemeImage<VALUE> {}
